import { render, staticRenderFns } from "./InteractiveTestViewer.vue?vue&type=template&id=47d9cd4e&scoped=true"
import script from "./InteractiveTestViewer.vue?vue&type=script&lang=js"
export * from "./InteractiveTestViewer.vue?vue&type=script&lang=js"
import style0 from "./InteractiveTestViewer.vue?vue&type=style&index=0&id=47d9cd4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d9cd4e",
  null
  
)

export default component.exports